import Banner from '../Banner/Banner.vue';

export default {
  components: {
    Banner,
  },
};
